export class fetchAdmins {
  static readonly type = '[SelectedSchoolAdmins] Fetch School Admins';
  constructor(public admins: any) {}
}

export class removeAdmins {
  static readonly type = '[SelectedSchoolAdmins] Remove School Admins';
}
